import { ethers } from 'ethers';

export const ADDRESS_ZERO = ethers.constants.AddressZero;
export const COLLAB_NFT_CONTRACT_ADDRESS_AURORA_TESTNET = '0x7F7b0fDe4f03A43E08DE9499d0229aD6b78887E7';
export const COLLAB_NFT_CONTRACT_ADDRESS_POLYGON_MUMBAI_TESTNET = '0x8F685656F7b1D31Dd6cD219eC6cc7989eB9F89fC';
export const COLLAB_LOCKER_CONTRACT_ADDRESS_AURORA_TESTNET = '0x78a8BD8ed2C20147cE81D941b4a51d01f0021Ec9';
export const COLLAB_BOT_ADDRESS = '0x1F62583538CDB2CB3656Ed43A46693F92DDa6302';
